import { render, staticRenderFns } from "./CharacterSheet.vue?vue&type=template&id=460cac6c&"
import script from "./CharacterSheet.vue?vue&type=script&lang=js&"
export * from "./CharacterSheet.vue?vue&type=script&lang=js&"
import style0 from "./CharacterSheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports